import { IDobroFormErrors } from 'shared/types/form';
import { locationVisible, priceDescriptionVisible } from 'shared/utils/dobroForm/visible';
import { IFormState } from '../../slices/formSlice/formSlice';
import { isValidEmail } from './isValidEmail';

export const initialErrorsState: IDobroFormErrors = {
  hasErrors: false,
  invalidFields: [],
  guestsCountErrorMessage: null,
  areaErrorMessage: null,
  floorErrorMessage: null,
  bedsCountErrorMessage: null,
  phoneErrorMessage: null,
  additionalPhoneErrorMessage: null,
  emailErrorMessage: null,
};

export const MIN_GUESTS_COUNT = 1;
export const MAX_GUESTS_COUNT = 100;
export const MIN_BEDS_COUNT = 1;
export const MAX_BEDS_COUNT = 100;
export const MIN_AREA = 1;
export const MAX_AREA = 1000;
export const MIN_FLOOR = -2;
export const MAX_FLOOR = 200;

export function validateForm(state: IFormState) {
  if (!state.submitted) {
    return;
  }

  state.errors = { ...initialErrorsState, invalidFields: [] };

  if (!state.data.objectType) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('objectType');
  }

  if (!state.data.moscow) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('moscow');
  }

  if (locationVisible(state) && state.data.location.trim() === '') {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('location');
  }

  if (state.data.address.trim() === '') {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('address');
  }

  if (state.data.guestsCount === null) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('guestsCount');
  } else if (state.data.guestsCount < MIN_GUESTS_COUNT) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('guestsCount');
    state.errors.guestsCountErrorMessage = `Минимальное количество гостей — ${MIN_GUESTS_COUNT}`;
  } else if (state.data.guestsCount > MAX_GUESTS_COUNT) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('guestsCount');
    state.errors.guestsCountErrorMessage = `Максимальное количество гостей — ${MAX_GUESTS_COUNT}. Если можете принять больше — обсудите это с сотрудником фонда.`;
  }

  if (state.data.bedsCount !== null && state.data.bedsCount < MIN_BEDS_COUNT) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('bedsCount');
    state.errors.bedsCountErrorMessage = `Минимальное количество спальных мест — ${MIN_BEDS_COUNT}`;
  } else if (state.data.bedsCount !== null && state.data.bedsCount > MAX_BEDS_COUNT) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('bedsCount');
    state.errors.bedsCountErrorMessage = `Максимальное количество спальных мест — ${MAX_BEDS_COUNT}. Если их больше — обсудите это с сотрудником фонда.`;
  }

  if (state.data.area !== null && state.data.area < MIN_AREA) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('area');
    state.errors.areaErrorMessage = `Минимальная площадь — ${MIN_AREA} м²`;
  } else if (state.data.area !== null && state.data.area > MAX_AREA) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('area');
    state.errors.areaErrorMessage = `Максимальная площадь — ${MAX_AREA} м². Если она больше — обсудите это с сотрудником фонда.`;
  }

  if (state.data.floor !== null && state.data.floor < MIN_FLOOR) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('floor');
    state.errors.floorErrorMessage = `Минимальный этаж — ${MIN_FLOOR}`;
  } else if (state.data.floor !== null && state.data.floor > MAX_FLOOR) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('floor');
    state.errors.floorErrorMessage = `Максимальный этаж — ${MAX_FLOOR}`;
  }

  if (!state.data.availablePeriod) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('availablePeriod');
  }

  if (!state.data.priceType) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('priceType');
  }

  if (state.data.readyAccommodate.length < 1) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('readyAccommodate');
  }

  if (priceDescriptionVisible(state) && state.data.priceDescription.trim() === '') {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('priceDescription');
  }

  if (state.data.phone.trim() === '') {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('phone');
  } else if (!/^\+7\d{10}$/.exec(state.data.phone)) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('phone');
    state.errors.phoneErrorMessage = 'Введите номер телефона в формате +7 999 999-99-99';
  }

  if (state.data.additionalPhone && !/^\+7\d{10}$/.exec(state.data.additionalPhone)) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('additionalPhone');
    state.errors.additionalPhoneErrorMessage = 'Введите номер телефона в формате +7 999 999-99-99';
  }

  if (state.data.name.trim() === '') {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('name');
  }

  if (!state.data.offerSigned) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('offerSigned');
  }

  if (!state.data.email) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('email');
  } else if (!isValidEmail(state.data.email)) {
    state.errors.hasErrors = true;
    state.errors.invalidFields.push('email');
    state.errors.emailErrorMessage = 'Неверный формат email';
  }
}
